module.exports = __webpack_public_path__ + "img/emptyState.e770fe10.svg";